(() => {
  'use strict';

  function initR4WSearch() {

    const root = document.getElementById('R4WCustomSearch');

    if (!root) return;

    if (root.dataset.initialized === 'true') return;

    root.dataset.initialized = 'true';


    /* -----------------------------------------
       ELEMENTS
    ----------------------------------------- */

    const input =
      root.querySelector('[data-r4w-search-input]');

    const empty =
      root.querySelector('[data-r4w-empty]');

    const results =
      root.querySelector('[data-r4w-results]');

    const loading =
      root.querySelector('[data-r4w-loading]');

    const noResults =
      root.querySelector('[data-r4w-no-results]');

    const resultList =
      root.querySelector('[data-r4w-product-results]');

    const productCount =
      root.querySelector('[data-r4w-product-count]');

    const queryText =
      root.querySelector('[data-r4w-query]');

    const noQuery =
      root.querySelector('[data-r4w-no-query]');

    const allResults =
      root.querySelector('[data-r4w-all-results]');


    /* -----------------------------------------
       PRODUCT INDEX
    ----------------------------------------- */

    let products = [];

    try {

      const index =
        document.getElementById(
          'R4WProductIndex'
        );

      if (index) {

        products =
          JSON.parse(
            index.textContent
          );

      }

    } catch (error) {

      console.error(
        'R4W Search: Product index error',
        error
      );

    }


    /* -----------------------------------------
       COLOR MAP
    ----------------------------------------- */

    const colorMap = {

      black: '#111111',

      white: '#ffffff',

      grey: '#a3a3a3',

      gray: '#a3a3a3',

      charcoal: '#3f3f3f',

      navy: '#172033',

      'navy blue': '#172033',

      red: '#9f1d20',

      green: '#52654b',

      'sky blue': '#9abbd1',

      blue: '#4f6f8a',

      cream: '#e9e3d7',

      beige: '#d7c6aa'

    };


    function swatchColor(value) {

      const key =
        String(value || '')
          .toLowerCase()
          .trim();

      return (
        colorMap[key] ||
        '#b5b5b5'
      );

    }


    /* -----------------------------------------
       ESCAPE
    ----------------------------------------- */

    function escapeHtml(value) {

      return String(value || '')
        .replace(/[&<>"']/g, character => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;'
        }[character]));

    }


    /* -----------------------------------------
       SEARCH TRIGGER
    ----------------------------------------- */

    const searchSelectors = [

      '.js-search-header',

      '.header-item--search',

      '.site-header__search-toggle',

      '[data-search-trigger]',

      '[aria-label*="search" i]'

    ];


    function isSearchTrigger(target) {

      if (
        !(target instanceof Element)
      ) {
        return false;
      }

      return searchSelectors.some(
        selector =>
          target.closest(selector)
      );

    }


    /* -----------------------------------------
       OPEN
    ----------------------------------------- */

    function openSearch() {

      const header =
        document.querySelector(
          '#SiteHeader, .site-header, .header-wrapper, .header-sticky-wrapper'
        );


      let headerHeight = 0;


      if (header) {

        const rect =
          header.getBoundingClientRect();

        headerHeight =
          rect.bottom;

      }


      root.style.setProperty(
        '--r4w-search-top',
        `${headerHeight}px`
      );


      root.hidden = false;


      document.body.classList.add(
        'r4w-search-open'
      );


      requestAnimationFrame(() => {

        if (input) {

          input.focus();

        }

      });

    }


    /* -----------------------------------------
       CLOSE
    ----------------------------------------- */

    function closeSearch() {

      root.hidden = true;


      document.body.classList.remove(
        'r4w-search-open'
      );


      if (input) {

        input.value = '';

      }


      showEmpty();

    }


    /* -----------------------------------------
       STATES
    ----------------------------------------- */

    function showEmpty() {

      empty.hidden = false;

      results.hidden = true;

      loading.hidden = true;

      noResults.hidden = true;

    }


    function showLoading() {

      empty.hidden = true;

      results.hidden = true;

      noResults.hidden = true;

      loading.hidden = false;

    }


    /* -----------------------------------------
       GET COLORS
    ----------------------------------------- */

    function getColors(product) {

      const colorOption =
        (product.options || [])
          .find(option =>
            /color|colour/i.test(
              option.name
            )
          );


      if (!colorOption) {

        return [];

      }


      return (
        colorOption.values || []
      ).slice(0, 5);

    }


    /* -----------------------------------------
       SCORE SEARCH
    ----------------------------------------- */

    function scoreProduct(
      product,
      query
    ) {

      const q =
        query.toLowerCase().trim();


      const title =
        String(product.title || '')
          .toLowerCase();

      const tags =
        String(product.tags || '')
          .toLowerCase();

      const type =
        String(product.product_type || '')
          .toLowerCase();


      let score = 0;


      if (title === q) {

        score += 100;

      }


      if (title.startsWith(q)) {

        score += 60;

      }


      if (title.includes(q)) {

        score += 40;

      }


      if (tags.includes(q)) {

        score += 20;

      }


      if (type.includes(q)) {

        score += 20;

      }


      const words =
        q.split(/\s+/);


      words.forEach(word => {

        if (
          word &&
          title.includes(word)
        ) {

          score += 10;

        }

      });


      return score;

    }


    /* -----------------------------------------
       SEARCH
    ----------------------------------------- */

    function searchProducts(query) {

      const clean =
        query.trim();


      if (!clean) {

        showEmpty();

        return;

      }


      showLoading();


      const ranked =
        products

          .map(product => ({

            product,

            score:
              scoreProduct(
                product,
                clean
              )

          }))

          .filter(item =>
            item.score > 0
          )

          .sort(
            (a, b) =>
              b.score - a.score
          );


      /*
       * Remove duplicate product titles.
       *
       * Your catalog contains some products
       * with separate color-specific products.
       * We don't want identical titles repeated.
       */

      const seen =
        new Set();


      const finalProducts = [];


      ranked.forEach(item => {

        const key =
          item.product.title
            .toLowerCase()
            .trim();


        if (
          seen.has(key)
        ) {
          return;
        }


        seen.add(key);

        finalProducts.push(
          item.product
        );

      });


      renderResults(
        finalProducts.slice(0, 8),
        clean
      );

    }


    /* -----------------------------------------
       RENDER RESULTS
    ----------------------------------------- */

    function renderResults(
      foundProducts,
      query
    ) {

      if (
        !foundProducts.length
      ) {

        results.hidden = true;

        loading.hidden = true;

        noResults.hidden = false;

        noQuery.textContent =
          query.toUpperCase();

        return;

      }


      productCount.textContent =
        `(${foundProducts.length})`;


      resultList.innerHTML =
        foundProducts
          .map(
            product =>
              renderProduct(
                product
              )
          )
          .join('');


      queryText.textContent =
        query.toUpperCase();


      allResults.href =
        `${window.R4WSearchConfig.searchUrl}?q=${encodeURIComponent(query)}`;


      empty.hidden = true;

      loading.hidden = true;

      noResults.hidden = true;

      results.hidden = false;


      bindSwatches();

    }


    /* -----------------------------------------
       PRODUCT RESULT
    ----------------------------------------- */

    function renderProduct(product) {

      const colors =
        getColors(product);


      const swatches =
        colors
          .map(color => {

            return `
              <button
                type="button"
                class="r4w-result-swatch"
                data-color="${escapeHtml(color)}"
                style="background:${swatchColor(color)}"
                aria-label="${escapeHtml(color)}"
                title="${escapeHtml(color)}"
              ></button>
            `;

          })
          .join('');


      return `

        <a
          class="r4w-search__result"
          href="${escapeHtml(product.url)}"
          data-product-id="${product.id}"
        >

          <span class="r4w-search__result-image">

            ${
              product.image
                ? `
                  <img
                    src="${escapeHtml(product.image)}"
                    alt="${escapeHtml(product.title)}"
                    loading="lazy"
                    data-product-image
                  >
                `
                : ''
            }

          </span>


          <span class="r4w-search__result-info">

            <strong>
              ${escapeHtml(product.title)}
            </strong>


            <span class="r4w-search__result-price">
              ${escapeHtml(product.price_formatted)}
            </span>


            ${
              swatches
                ? `
                  <span
                    class="r4w-search__result-swatches"
                  >
                    ${swatches}
                  </span>
                `
                : ''
            }

          </span>


          <span
            class="r4w-search__result-arrow"
          >
            →
          </span>

        </a>

      `;

    }


    /* -----------------------------------------
       SWATCHES
    ----------------------------------------- */

    function bindSwatches() {

      const cards =
        resultList.querySelectorAll(
          '.r4w-search__result'
        );


      cards.forEach(card => {

        const productId =
          card.dataset.productId;


        const product =
          products.find(
            item =>
              String(item.id) ===
              String(productId)
          );


        if (!product) {
          return;
        }


        const image =
          card.querySelector(
            '[data-product-image]'
          );


        const swatches =
          card.querySelectorAll(
            '.r4w-result-swatch'
          );


        swatches.forEach(
          swatch => {

            swatch.addEventListener(
              'click',
              event => {

                event.preventDefault();

                event.stopPropagation();


                const color =
                  swatch.dataset.color;


                const variant =
                  (product.variants || [])
                    .find(variant => {

                      return (
                        variant.options ||
                        []
                      ).some(
                        value =>
                          String(value)
                            .toLowerCase() ===
                          String(color)
                            .toLowerCase()
                      );

                    });


                if (
                  variant &&
                  variant.image &&
                  image
                ) {

                  image.src =
                    variant.image;

                }


                swatches.forEach(
                  item =>
                    item.classList.remove(
                      'is-active'
                    )
                );


                swatch.classList.add(
                  'is-active'
                );

              }
            );

          }
        );

      });

    }


    /* -----------------------------------------
       CLICK OUTSIDE / TRIGGER
    ----------------------------------------- */

    document.addEventListener(
      'click',
      event => {

        /*
         * Don't intercept clicks inside
         * our custom search.
         */

        if (
          root.contains(
            event.target
          )
        ) {

          return;

        }


        if (
          !isSearchTrigger(
            event.target
          )
        ) {

          return;

        }


        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        openSearch();

      },
      true
    );


    /* -----------------------------------------
       CLOSE BUTTON
    ----------------------------------------- */

    root.addEventListener(
      'click',
      event => {

        if (
          event.target.closest(
            '[data-r4w-search-close]'
          )
        ) {

          event.preventDefault();

          closeSearch();

        }

      }
    );


    /* -----------------------------------------
       INPUT
    ----------------------------------------- */

    let timer;


    if (input) {

      input.addEventListener(
        'input',
        () => {

          clearTimeout(timer);


          timer =
            setTimeout(
              () => {

                searchProducts(
                  input.value
                );

              },
              80
            );

        }
      );


      input.addEventListener(
        'keydown',
        event => {

          if (
            event.key === 'Escape'
          ) {

            event.preventDefault();

            closeSearch();

          }

        }
      );

    }


    /* -----------------------------------------
       POPULAR SEARCH
    ----------------------------------------- */

    root
      .querySelectorAll(
        '[data-r4w-popular]'
      )
      .forEach(link => {

        link.addEventListener(
          'click',
          event => {

            event.preventDefault();


            const term =
              link.dataset.r4wPopular ||
              '';


            input.value =
              term;


            searchProducts(
              term
            );

          }
        );

      });


    /* -----------------------------------------
       GLOBAL ESCAPE
    ----------------------------------------- */

    document.addEventListener(
      'keydown',
      event => {

        if (
          event.key === 'Escape' &&
          !root.hidden
        ) {

          closeSearch();

        }

      }
    );


    /* -----------------------------------------
       RESIZE
    ----------------------------------------- */

    window.addEventListener(
      'resize',
      () => {

        if (root.hidden) {
          return;
        }


        const header =
          document.querySelector(
            '#SiteHeader, .site-header, .header-wrapper, .header-sticky-wrapper'
          );


        if (!header) {
          return;
        }


        const height =
          header.getBoundingClientRect()
            .bottom;


        root.style.setProperty(
          '--r4w-search-top',
          `${height}px`
        );

      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initR4WSearch
    );

  } else {

    initR4WSearch();

  }


})();


(function () {
  'use strict';

  function initR4WProductGridSliders() {
    const sliders = document.querySelectorAll(
      '[data-r4w-product-grid-slider]'
    );

    sliders.forEach(function (slider) {
      if (slider.dataset.r4wSliderInitialized === 'true') {
        return;
      }

      slider.dataset.r4wSliderInitialized = 'true';

      const track = slider.querySelector(
        '.r4w-product-grid-slider__track'
      );

      const slides = slider.querySelectorAll(
        '.r4w-product-grid-slider__slide'
      );

      const leftZone = slider.querySelector(
        '.r4w-product-grid-slider__zone--left'
      );

      const rightZone = slider.querySelector(
        '.r4w-product-grid-slider__zone--right'
      );

      if (!track || slides.length <= 1) {
        return;
      }

      let currentIndex = 0;

      /*
       * Prevent multiple changes from a single mouse movement.
       */
      let lastHoverZone = null;

      /*
       * Touch/swipe variables.
       */
      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartTime = 0;

      function updateSlider(animate) {
        if (!animate) {
          track.style.transition = 'none';
        } else {
          track.style.transition = '';
        }

        track.style.transform =
          'translate3d(-' + (currentIndex * 100) + '%, 0, 0)';

        if (!animate) {
          /*
           * Force browser to register the no-transition state
           * before restoring the transition.
           */
          track.offsetHeight;
          track.style.transition = '';
        }

        slider.dataset.currentSlide = currentIndex;
      }

      function goNext() {
        if (currentIndex >= slides.length - 1) {
          return;
        }

        currentIndex += 1;
        updateSlider(true);
      }

      function goPrevious() {
        if (currentIndex <= 0) {
          return;
        }

        currentIndex -= 1;
        updateSlider(true);
      }

      /*
       * -------------------------------------------------------
       * DESKTOP HOVER
       * -------------------------------------------------------
       */

      if (leftZone) {
        leftZone.addEventListener('mouseenter', function () {
          /*
           * Only move once when entering the zone.
           * This prevents the image from rapidly changing
           * while the mouse remains still.
           */
          if (lastHoverZone !== 'left') {
            lastHoverZone = 'left';
            goPrevious();
          }
        });

        leftZone.addEventListener('mouseleave', function () {
          if (lastHoverZone === 'left') {
            lastHoverZone = null;
          }
        });
      }

      if (rightZone) {
        rightZone.addEventListener('mouseenter', function () {
          if (lastHoverZone !== 'right') {
            lastHoverZone = 'right';
            goNext();
          }
        });

        rightZone.addEventListener('mouseleave', function () {
          if (lastHoverZone === 'right') {
            lastHoverZone = null;
          }
        });
      }

      /*
       * -------------------------------------------------------
       * MOBILE SWIPE
       * -------------------------------------------------------
       */

      slider.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || !event.touches.length) {
            return;
          }

          const touch = event.touches[0];

          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          touchStartTime = Date.now();

          slider.classList.add('is-dragging');
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchend',
        function (event) {
          slider.classList.remove('is-dragging');

          if (!event.changedTouches || !event.changedTouches.length) {
            return;
          }

          const touch = event.changedTouches[0];

          const deltaX = touch.clientX - touchStartX;
          const deltaY = touch.clientY - touchStartY;
          const elapsed = Date.now() - touchStartTime;

          /*
           * Minimum horizontal swipe distance.
           */
          const swipeThreshold = 40;

          /*
           * Only treat it as a swipe when horizontal movement
           * is greater than vertical movement.
           */
          const isHorizontalSwipe =
            Math.abs(deltaX) > swipeThreshold &&
            Math.abs(deltaX) > Math.abs(deltaY);

          if (!isHorizontalSwipe) {
            return;
          }

          /*
           * Left swipe = next image
           * Right swipe = previous image
           */
          if (deltaX < 0) {
            goNext();
          } else {
            goPrevious();
          }
        },
        { passive: true }
      );

      /*
       * -------------------------------------------------------
       * PREVENT THE PRODUCT LINK FROM NAVIGATING AFTER A SWIPE
       * -------------------------------------------------------
       */

      let wasSwiping = false;

      slider.addEventListener(
        'touchstart',
        function () {
          wasSwiping = false;
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchmove',
        function (event) {
          if (!event.touches || !event.touches.length) {
            return;
          }

          const deltaX = event.touches[0].clientX - touchStartX;
          const deltaY = event.touches[0].clientY - touchStartY;

          if (
            Math.abs(deltaX) > 20 &&
            Math.abs(deltaX) > Math.abs(deltaY)
          ) {
            wasSwiping = true;
          }
        },
        { passive: true }
      );

      slider.addEventListener(
        'click',
        function (event) {
          if (wasSwiping) {
            event.preventDefault();
            event.stopPropagation();

            wasSwiping = false;
          }
        },
        true
      );

      /*
       * Make sure first slide is correctly positioned.
       */
      updateSlider(false);
    });
  }

  /*
   * Initial load.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initR4WProductGridSliders
    );
  } else {
    initR4WProductGridSliders();
  }

  /*
   * Shopify/Impulse can dynamically reload sections.
   */
  document.addEventListener(
    'shopify:section:load',
    function () {
      initR4WProductGridSliders();
    }
  );

  /*
   * Also expose it in case another theme script needs
   * to reinitialize product cards.
   */
  window.R4WProductGridSliders = {
    init: initR4WProductGridSliders
  };
})();